import {Chart} from '../../Chart';
import {SensorChartRenderer} from './SensorChartRenderer';
import {SensorChartRenderContext} from './SensorChartRenderContext';
import {NumericAxis, TimelineAxis} from '../../Axis';
import {AutoScale, RatioScale} from '../../Scale';
import {TimeSeries} from '../../Series';
import * as JQuery from 'jquery';

	export  class SensorChart extends Chart {

		private _timeline: TimelineAxis;
		private _numericAxis: NumericAxis;

		public constructor(element: string | Element | JQuery){

			super(element);
			//x-axis
			this._timeline = new TimelineAxis(
				new RatioScale(1000, RatioScale.PX_PER_CM));
			//y-axis
			this._numericAxis = new NumericAxis(
				new AutoScale({niceRound: true}));

			this.setAxes(this._timeline, this._numericAxis);

			//grid options
			this.options.grid.interval = {
				x: {major: 1000, minor: 200}
			};

			this.redraw();
		}

		protected createRenderer() {
			return new SensorChartRenderer();
		}

		protected createRenderContext(container: string | Element | JQuery) {
			return new SensorChartRenderContext(container);
		}

		public setData(data: [number, number][]) {
			var sampleDataSeries = new TimeSeries("Sample Data");
			sampleDataSeries.values = data;

			this.setSeries(sampleDataSeries);
			this.redraw();
		}

		public setUnitOfMeasure(uom: string = "") {
			this._numericAxis.unitOfMeasure = uom;
		}

		public setStartTime(timestamp: number) {
			this._timeline.setStartTime(timestamp);
		}

		public setEndTime(timestamp: number) {
			this._timeline.setEndTime(timestamp);
		}

		public redraw() {
			this.shortenData();
			super.redraw();
		}

		protected shortenData() {
			this.context.seriesConfiguration.series.forEach(series => {
				while(series.values.length > 0) {
					var item = series.values.shift();
					var time = series.valueProvider.getX(item);
					if(time >= this._timeline.minimum) {
						series.values.unshift(item);
						break;
					}
				}
			});
		}

	}

